export default "__VITE_ASSET__DplUkujo__"